import { formatCode, formatDateTZ, formatDuration, formatMoney } from "./format";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.ponos.app";

export type WelcomeMessageInput = {
  code: string;
  sold_to_name: string | null;
  duration_days: number;
  price_cents: number;
  currency: string;
  code_expires_at: string;
  partnerName: string;
  partnerTimezone: string;
};

/**
 * Genera un mensaje formateado listo para pegar en WhatsApp con el código
 * de activación PRO y las instrucciones para el cliente.
 * Usa asteriscos `*texto*` que WhatsApp interpreta como bold.
 */
export function buildWelcomeMessage(input: WelcomeMessageInput): string {
  const formattedCode = formatCode(input.code);
  const greeting = input.sold_to_name ? `¡Hola ${input.sold_to_name}! 👋` : "¡Hola! 👋";
  const expires = formatDateTZ(input.code_expires_at, input.partnerTimezone);

  return [
    greeting,
    "",
    `Gracias por adquirir tu suscripción NIUFIT PRO a través de *${input.partnerName}*.`,
    "",
    `📱 *Tu código de activación:* ${formattedCode}`,
    "",
    "📋 *Detalles*",
    `• Plan: ${formatDuration(input.duration_days)} (${input.duration_days} días)`,
    `• Precio: ${formatMoney(input.price_cents, input.currency)}`,
    `• Válido para canjear hasta: ${expires}`,
    "",
    "*¿Cómo activarlo?*",
    `1. Descarga la app NiuFit: ${PLAY_STORE_URL}`,
    "2. Crea tu cuenta o inicia sesión",
    "3. Ingresa a la sección de suscripción o al perfil",
    `4. Ingresa el código *${formattedCode}* y actívalo`,
    "",
    "¡Bienvenido a NIUFIT PRO! 💪",
  ].join("\n");
}
